"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedIcon = exports.FeedIconMap = exports.useFeedIconBg = exports.feedIconTestIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const insights_engine_models_1 = require("@forto-dev/insights-engine-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const types_1 = require("../types");
const ActivityIcons_1 = require("./ActivityIcons");
exports.feedIconTestIds = {
    feedIconWrapper: 'activity_feed-icon_wrapper',
};
const useFeedIconBg = () => {
    const bgMap = (0, ActivityIcons_1.useIconBg)();
    return {
        [types_1.ActivityType.DeviationRiskInsight]: bgMap.deviationRisk,
        [types_1.ActivityType.DeviationInsight]: bgMap.deviation,
        [types_1.ActivityType.UpdateInsight]: bgMap.update,
        [types_1.ActivityType.ReassuranceInsight]: bgMap.reassurance,
        [types_1.ActivityType.Approval]: bgMap.approval,
        [types_1.ActivityType.OpenTasks]: bgMap.approval,
        [types_1.ActivityType.MessageFeedV1]: bgMap.update,
        [types_1.ActivityType.CommunicationFeedV1]: bgMap.update,
        [types_1.ActivityType.Update]: bgMap.update,
        [types_1.ActivityType.Activity]: bgMap.update,
        [types_1.ActivityType.DocumentUploadFeedV1]: bgMap.approval,
        [insights_engine_models_1.RuleID.MoT04_EV01_CRD_Other]: bgMap.update,
    };
};
exports.useFeedIconBg = useFeedIconBg;
exports.FeedIconMap = {
    [types_1.ActivityType.DeviationRiskInsight]: ActivityIcons_1.DeviationRiskInsightIcon,
    [types_1.ActivityType.DeviationInsight]: ActivityIcons_1.IconMap.deviation,
    [types_1.ActivityType.UpdateInsight]: ActivityIcons_1.IconMap.update,
    [types_1.ActivityType.ReassuranceInsight]: ActivityIcons_1.ReassuranceInsightIcon,
    [types_1.ActivityType.Approval]: ActivityIcons_1.IconMap.approval,
    [types_1.ActivityType.OpenTasks]: ActivityIcons_1.IconMap.openTasks,
    [types_1.ActivityType.MessageFeedV1]: ActivityIcons_1.IconMap.message,
    [types_1.ActivityType.CommunicationFeedV1]: ActivityIcons_1.IconMap.message,
    [types_1.ActivityType.Update]: ActivityIcons_1.IconMap.update,
    [types_1.ActivityType.DocumentUploadFeedV1]: ActivityIcons_1.IconMap.openTasks,
    [insights_engine_models_1.RuleID.MoT04_EV01_CRD_Other]: ActivityIcons_1.IconMap.update,
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => {
    const iconBgMap = (0, exports.useFeedIconBg)();
    return {
        iconWrapperBox: ({ type, ruleID }) => ({
            width: 32,
            height: 32,
            background: iconBgMap[ruleID] || iconBgMap[type] || iconBgMap[types_1.ActivityType.Activity],
            borderRadius: 5,
            flex: 'none',
            marginRight: theme.spacing(1.5),
        }),
    };
});
const FeedIcon = ({ type, ruleID, Icon }) => {
    const classes = useStyles({ type, ruleID });
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { container: true, justifyContent: "center", className: classes.iconWrapperBox, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", alignItems: "center", "data-testid": exports.feedIconTestIds.feedIconWrapper, children: (0, jsx_runtime_1.jsx)(Icon, {}) }) }));
};
exports.FeedIcon = FeedIcon;
//# sourceMappingURL=FeedIcon.js.map